import React from 'react';
import { Icons, Ico } from './Icons';

const Toast = ({ message, type = 'success', isVisible, onClose }) => {
  if (!isVisible) return null;

  const config = {
    success: {
      bg: '#43A047',
      icon: Icons.check,
      iconColor: '#fff'
    },
    error: {
      bg: '#E53935',
      icon: Icons.close,
      iconColor: '#fff'
    },
    warning: {
      bg: '#FB8C00',
      icon: Icons.alert,
      iconColor: '#fff'
    },
    info: {
      bg: '#1E88E5',
      icon: Icons.info,
      iconColor: '#fff'
    }
  };

  const { bg, icon, iconColor } = config[type] || config.success;

  return (
    <div 
      style={{ 
        position: 'fixed', 
        top: window.innerWidth <= 768 ? 70 : 20, 
        left: '50%', 
        transform: 'translateX(-50%)', 
        zIndex: 9999, 
        background: bg, 
        color: '#fff', 
        padding: '12px 24px', 
        borderRadius: 10, 
        boxShadow: `0 4px 16px ${bg}4D`, 
        display: 'flex', 
        alignItems: 'center', 
        gap: 8, 
        fontSize: 14, 
        fontWeight: 600, 
        animation: 'slideDown 0.3s ease', 
        maxWidth: 'calc(100vw - 32px)' 
      }}
    >
      <Ico d={icon} size={16} color={iconColor} />
      {message}
    </div>
  );
};

export default Toast;
